import axios from 'axios';
import cookie from 'webmd-cookie';

/**
 * Gets site
 * @return {number}
 */
const getSite = function() {
    const host = document.location.hostname;

    if (host.indexOf('webmd.com') > -1) {
        return 1;
    } else if (host.indexOf('medicinenet.com') > -1) {
        return 2;
    } else if (host.indexOf('emedicinehealth.com') > -1) {
        return 3;
    } else if (host.indexOf('rxlist.com') > -1) {
        return 4;
    } else if (host.indexOf('onhealth.com') > -1) {
        return 5;
    } else if (host.indexOf('vitals.com') > -1) {
        return 8;
    } else {
        return 1;
    }
};

/**
 * Get correct API for current page (devint for localhost testing)
 * @returns {string}
 */
let getApi = () => {
    let host = document.location.hostname;

    if (host.includes('localhost')) {
        return 'https://www.devint.webmd.com/mm/choose'
    } else if (host.includes('feature') || host.includes('devint')) {
        return 'https://www.devint.webmd.com/mm/choose'
    } else if (host.includes('qa')) {
        return 'https://www.qa.webmd.com/mm/choose'
    } else if (host.includes('preview')) {
        return 'https://www.preview.webmd.com/mm/choose'
    } else if (host.includes('staging') && host.includes('blogs')) {
        return 'https://blogs.staging.webmd.com/mm/choose'
    } else if (host.includes('staging') && host.includes('symptoms')) {
        return 'https://symptoms.staging.webmd.com/mm/choose'
    } else if (host.includes('staging')) {
        return 'https://www.staging.webmd.com/mm/choose'
    } else if (host.includes('blogs')) {
        return 'https://blogs.webmd.com/mm/choose'
    } else if (host.includes('symptoms')) {
        return 'https://symptoms.webmd.com/mm/choose'
    } else {
        return 'https://www.webmd.com/mm/choose'
    }
}

/**
 * Get ML Model from CMT cookie (if available)
 * @return {string|null} ml campaign string
 */
let getMl = function() {
    let cmt = cookie.get('cmt') !== '' ? JSON.parse(decodeURIComponent(cookie.get('cmt'))) : false;

    if (cmt && cmt.campaigns) {
        return cmt.campaigns.join(',');
    }

    return null;
};

/**
 * Get creatives via choose api with params from user and page
 *  @param api
 *  @param params
 * @returns {Promise<boolean|any>}
 */
let getCreatives = async (api, params) => {

    let results = await axios.get(api, {
        params,
    });

    if (results) {
        return results.data;
    }

    return false;
}

/**
 * Get environment (0 for prod LIVE, 1 for everything else)
 * @returns {number}
 */
let getEnv = () => {
    let host = document.location.hostname;

    if (
        host.includes('staging') ||
        host.includes('preview') ||
        host.includes('devint') ||
        host.includes('qa') ||
        host.includes('feature') ||
        host.includes('localhost')
    ) {
        return 1;
    } else {
        return 0;
    }
}

let getSource = () => {
    let url = new URL(document.location.href);
    let ecd = url.searchParams.get('ecd');
    let smDomains = ['12seconds.tv','t.163.com','4travel.jp','advogato.org','ameba.jp','anobii.com','asmallworld.net','avforums.com','backtype.com','badoo.com','bebo.com','bigadda.com','bigtent.com','biip.no','blackplanet.com','blogspot.com','blogster.com','blomotion.jp','bolt.com','brightkite.com','buzznet.com','cafemom.com','care2.com','classmates.com','cloob.com','collegeblender.com','cyworld.co.kr','cyworld.com.cn','dailymotion.com','yozm.daum.net','delicious.com','deviantart.com','digg.com','diigo.com','disqus.com','draugiem.lv','facebook.com','faceparty.com','fc2.com','flickr.com','flixster.com','fotolog.com','foursquare.com','friendfeed.com','friendsreunited.com','friendsreunited.co.uk','friendster.com','fubar.com','gaiaonline.com','geni.com','goodreads.com','plus.google.com','plus.url.google.com','grono.net','habbo.com','hatena.ne.jp','t.hexun.com','hi5.com','hyves.nl','ibibo.com','identi.ca','t.ifeng.com','imeem.com','hotnews.infoseek.co.jp','instagram.com','intensedebate.com','irc-galleria.net','iwiw.hu','jaiku.com','kaixin001.com','kaixin002.com','kakaku.com','kanshin.com','kozocom.com','last.fm','linkedin.com','livejournal.com','lnkd.in','me2day.net','meetup.com','mister-wong.com','mixi.jp','mixx.com','mouthshut.com','multiply.com','mumsnet.com','myheritage.com','mylife.com','myspace.com','myyearbook.com','nasza-klasa.pl','matome.naver.jp','netlog.com','nettby.no','netvibes.com','nextdoor.com','nicovideo.jp','ning.com','odnoklassniki.ru','ok.ru','orkut.com','pakila.jp','t.people.com.cn','photobucket.com','pinterest.com (and all international domains)','plaxo.com','plurk.com','po.st','t.qq.com','mp.weixin.qq.com','boards.qwant.com','reddit.com','renren.com','blog.seesaa.jp','t.sina.com.cn','skyrock.com','slideshare.net','smcb.jp','smugmug.com','t.sohu.com','sonico.com','studivz.net','stumbleupon.com','t.co','tabelog.com','tagged.com','taringa.net','thefancy.com','toutiao.com','tripit.com','trombi.com','trytrend.jp','tuenti.com','tumblr.com','twine.com','twitter.com','uhuru.jp','viadeo.com','vimeo.com','vk.com','wayn.com','weibo.com','weourfamily.com','wer-kennt-wen.de','wordpress.com','xanga.com','xing.com','answers.yahoo.com','yammer.com','yaplog.jp','yelp.com','yelp.co.uk','youku.com','youtube.com','yuku.com','zooomr.com','zhihu.com'];
    let seoDomains = ['google.com','bing.com','yahoo.com','baidu.com','yandex.ru','duckduckgo.com','ask.com','ecosia.org','aol.com','archive.org'];

    // ECD Check
    if (ecd && ecd.includes('wnl')) {
        return 3;
    } else if (ecd && ecd.includes('soc')) {
        return 4;
    }

    // No Ref check
    if (!document.referrer || document.referrer === '') {
        return 1;
    }

    // Internal ref
    if (document.referrer.includes('webmd.com')) {
        return 5;
    }

    // SM ref check
    if (smDomains.some(s => document.referrer.includes(s))) {
        return 4;
    }

    // SEO ref check
    if (seoDomains.some(s => document.referrer.includes(s))) {
        return 2;
    }

    return 6;
}

/**
 * Get device type (mobile or desktop)
 * @returns {string}
 */
let getDevice = () => {
    return window.matchMedia("(max-width: 466px)").matches ? 'mobile' : 'desktop';
}

/**
 * Get params for the API call, using optional override params or page variables if present
 * Also uses gtinfo cookie manually on localhost for testing, since x-domain cookies won't work
 * @param overrideParams
 * @returns {{}}
 */
let getParams = (overrideParams) => {
    let params = {};
    let override = overrideParams || {};
    let gtinfo = cookie.get('gtinfo') !== '' ? JSON.parse(cookie.get('gtinfo')) : false;

    params.ch = override.channel || window.center_id || undefined;
    params.tp = override.topic || window.s_topic || undefined;
    params.sp = override.specialty || undefined;
    params.br = override.br || window.busref_id || undefined;
    params.s = override.s || getSite();
    params.env = override.env || getEnv();
    params.dv = override.dv || getDevice();
    params.url = override.url || document.location.hostname + document.location.pathname;
    params.a = override.a || 1;
    params.ts = override.ts || getSource();
    params.ml = override.ml || getMl() || undefined;
    params.l = (override.l || window.s_language_locale || 'en_us').toLowerCase();
    params.cbp = override.cbp || window.s_sponsor_program || undefined;

    // If localhost, set geo params manually from gtinfo cookie
    if (gtinfo) {
        params.cntr = override.cntr || gtinfo.cntr;
        params.st = override.st || gtinfo.st;
        params.dma = override.dma || gtinfo.dma;
        params.zip = override.zip || gtinfo.z;
    }

    return params;
}

let wdl = {

    /**
     * Get creatives for a specific module via the API and return to the caller asynchronously
     * @param options
     * @returns {Promise<any|boolean>}
     */
    fill: async (options) => {
        let items = false;
        let api;
        let params = {
            mod: options.module,
            num: options.count
        };
        // If no module or count passed, fail out
        if (!options.module || !options.count) {
            console.error('WebMD Dynamic Links Error: Module ID and Count required')
            return false;
        }

        if (options.api) {
            api = options.api;
        } else {
            api = getApi();
        }

        if (typeof window !== 'undefined') {

            // Build params from page variables merged with optional override params from user
            params = Object.assign({}, params, getParams(options.params));

            // Get creatives
            try {
                items = await getCreatives(api, params);
            } catch (err) {
                return false;
            }

            // If there are creatives, add this module to a window object for tracking, return the items
            if (window.webmd && window.webmd.wdl && window.webmd.wdl.modules) {
                window.webmd.wdl.modules[options.module] = options;
            }

            if (items) {
                return items;
            }

            return false;
        }
    },

    /**
     * Send refresh event to refresh modules from outside code
     * @param module
     */
    refresh: (module) => {
        if (typeof window !== 'undefined') {
            let event = new CustomEvent('webmd.wdl.refresh', {detail: module});
            document.dispatchEvent(event);
        }
    }
}

if (typeof window !== 'undefined' && window.webmd) {
    window.webmd.wdl = window.webmd.wdl || {
        modules: {},
        refresh: wdl.refresh
    };
}

export default wdl;
